let PackagesItem = [
    {
        id: 1,
        trackTitle: "Senior Track",
        trackSubtitle: "for experienced NODE JS Developers",
        trackPrice: "$99",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1642500441691x469916138631594000',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "for junior NODE JS developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1642524405303x715531716143087600',
    },
  ];
  
  export default PackagesItem;
  